















































































import BaseComponent from '@/components/base-component.vue';
import ArrayUtils from '@/helpers/arrayUtils';
import { listClients } from '@/services/clients';
import { getSelectedClientFromLocal } from '@/services/session-data';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiAutocompleClientsSubsidiaries extends BaseComponent {
  @Prop()
  public value: any;
  @Prop({default: false})
  public showIcon?: boolean;
  @Prop()
  public label?: string;
  @Prop()
  public placeholder?: string;
  @Prop()
  public required?: boolean;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public readonly?: boolean;
  @Prop()
  public rules?: any[];
  @Prop()
  public multiple?: boolean;
  @Prop()
  public chips?: boolean;
  @Prop()
  public clearable?: boolean;
  @Prop()
  public deletableChips?: boolean;
  @Prop()
  public tabIndex?: string;
  @Prop()
  public clients?: any[];
  @Prop({
    default: false,
  })
  public showInactives?: boolean;
  @Prop({
    default: false,
  })
  public loadEnderecos?: boolean;
  @Prop({
    default: false,
  })
  public returnEnderecosInativos?: boolean;
   @Prop({
    default: false,
  })
  public allClientsUnits?: boolean;

  @Prop()
  public idsBusinessUnit?: any[];
  
  @Prop({ default: true })
  public showClientsEmptyBusinessUnit?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop()
  public hint?: string;

  @Prop({default: false})
  public persistentHint?: boolean;

  public attr = {
    suffix: '',
    label: 'Cliente / Unidade *',
    placeholder: 'Digite o nome do cliente ou da unidade',
    required: false,
    rules: [],
    multiple: false,
    chips: false,
    clearable: false,
    deletableChips: false,
    disabled: false,
  };

  public subsidiaries: any = [];
  public item: any = null;
  public loading: boolean = false;

  @Watch('value')
  public onChangeValue(val: any): void {
    this.item = val;
    if (!this.loading) {
      this.setCurrentItem(val);
    }
  }

  @Watch('idsBusinessUnit')
  onIdsBusinessUnitChange(idsNew, idsOld) {
    if (ArrayUtils.equalsIgnoreOrder(idsNew, idsOld)) {
      return;
    }
    this.getClients();
  }

  @Watch('clients')
  public onChangeClients(val: any[]): void {
    if (!!val) {
      this.subsidiaries = this.flatSubisidiaries(val);

      if (!this.isEmede()) {
        this.selectCurrentClientUnit();
      } else {
        this.setCurrentItem(val);
      }
    } else {
      this.getClients();
    }
  }

  @Watch('rules')
  public onChangeRules(val): void {
    this.attr.rules = val || this.attr.rules;
  }

  public updated(): void {
    if (!!this.item && (!!this.item.length || !!this.item.id)) {
      return;
    }

    if (!this.isEmede()) {
      this.selectCurrentClientUnit();
    }
  }

  public beforeMount(): void {
    this.attr.label = this.label || this.attr.label;
    this.attr.placeholder = this.placeholder || this.attr.placeholder;
    this.attr.required =
      typeof this.required !== 'undefined' || this.attr.required;
    this.attr.rules = this.rules || this.attr.rules;
    this.attr.multiple =
      typeof this.multiple !== 'undefined' || this.attr.multiple;
    this.attr.chips = typeof this.chips !== 'undefined' || this.attr.chips;
    this.attr.clearable =
      typeof this.clearable !== 'undefined' || this.attr.clearable;
    this.attr.deletableChips =
      typeof this.deletableChips !== 'undefined' || this.attr.deletableChips;

    if (!!this.clients) {
      this.subsidiaries = this.flatSubisidiaries(this.clients);

      if (!this.isEmede()) {
        this.selectCurrentClientUnit();
      }
    } else {
      this.getClients();
    }

    this.onChangeValue(this.value);
  }

  public onFilter(item: any, queryText: string, itemText: any): boolean {
    if (!!item.header) {
      return item.header.toLowerCase().indexOf(queryText.toLowerCase()) !== -1;
    } else if (!!item.cliente) {
      return (
        item.nome.toLowerCase().indexOf(queryText.toLowerCase()) !== -1 ||
        item.cliente.nome.toLowerCase().indexOf(queryText.toLowerCase()) !== -1 ||
        (!!item.cliente.nomeFantasia && item.cliente.nomeFantasia.toLowerCase().indexOf(queryText.toLowerCase()) !== -1)
      );
    } else if (typeof itemText === 'string') {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) !== -1;
    }
  }

  public onRemove(item: any): void {
    const index = this.returnObject ? this.item.findIndex((el) => el.id === item.id) : this.item.findIndex((el) => el === item.id);

    const NOT_FOUND = -1;
    if (index !== NOT_FOUND) {
      this.item = Object.assign(new Array(), this.item);
      this.item.splice(index, 1);
      this.onChange(this.item);
    }
  }

  public onChange(val): void {
    this.$emit('input', this.item);
    this.$emit('change', val);
  }

  private setCurrentItem(currentItem: any): void {
    const itemExist = () =>
      this.subsidiaries.some((item) => item.id === currentItem.id);
    if (!!currentItem && !!currentItem.id && !itemExist()) {
      this.subsidiaries.push(currentItem);
    }
  }

  private getClients(): void {
    this.subsidiaries = [];
    if (!this.showClientsEmptyBusinessUnit && (!this.idsBusinessUnit || !this.idsBusinessUnit.length)) {
      this.$emit('input', null);
      this.$emit('change', null);
      return;
    }

    this.loading = true;

    const status = !this.showInactives ? true : null;

    listClients(status, this.idsBusinessUnit).subscribe(
      (data) => {
        this.loading = false;

        let units = [];
        data.forEach(c => units = units.concat(c.unidades));
        if (this.item) {
          if (this.item.length) {
            this.item = this.item.filter(i => units.findIndex(u => u.id == i || u.id == i.id) >=0);
          } else if (units.findIndex(u => u.id == this.item || u.id == this.item.id) == -1) {
            this.item = null;
          }
        }

        this.subsidiaries = this.flatSubisidiaries(data);

        if (!this.isEmede()) {
          this.selectCurrentClientUnit();
        } else {
          this.setCurrentItem(this.value);
        }

        this.$emit('input', this.item);
        this.$emit('change', this.item);
      },
      () => {
        this.loading = false;
      },
    );
  }

  private flatSubisidiaries(clients: any[]): any[] {
    if (!clients) {
      return [];
    }

    return clients.reduce((acc, cliente) => {
      if (!cliente.unidades) {
        return acc.concat(cliente);
      }

      let items = [];
      items = items.concat(
        cliente.unidades.map((subsidiary, index) => {
          return {
            ...subsidiary,
            cliente,
          };
        }),
      );

      items.unshift({ header: cliente.nome });
      items.push({ divider: true });

      return acc.concat(items);
    }, []);
  }

  private selectCurrentClientUnit(): void {
    if (this.item && this.item.length) {
      return;
    }
    getSelectedClientFromLocal().subscribe((data) => {
      if (!!data) {
        let item = this.subsidiaries.find((unit) => {
          return data.id === unit.id;
        });
        if (!this.returnObject && item) {
          item = item.id;
        }

        if (!!item) {
          if (this.attr.multiple) {
            this.item = [item];
          } else {
            this.item = item;
          }

          this.attr.disabled = !this.allClientsUnits;          
          this.onChange(this.item);
        }
      }
    });
  }
}
